<div class="MainPod">
  <h2>Refer to docs to provide a custom cpnt here </h2>
  <div class="Pod0">
    <div *ngFor="let square of amount;let index = index" [class]="'Pod0Item'+index"></div>
  </div>
</div>
